const WISHLIST_KEY = 'wishlist';

function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
}

function saveWishlist(list) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  document.dispatchEvent(new CustomEvent('wishlist:updated'));
}

// Función principal de Toggle (Funciona en Producto y Archive)
function toggleWishlist(productId, button) {
  let wishlist = getWishlist();
  productId = productId.toString();
  const isActive = wishlist.includes(productId);

  if (isActive) {
    wishlist = wishlist.filter(id => id !== productId);
    button.classList.remove('is-active');
    button.setAttribute('aria-label', 'Agregar a favoritos');
    
    // Si estamos en la página de "Personal Archive", eliminamos la tarjeta con estilo
    const itemInPage = button.closest('[data-wishlist-item]');
    if (itemInPage) {
      itemInPage.style.opacity = '0';
      itemInPage.style.transform = 'scale(0.9)';
      setTimeout(() => {
        itemInPage.remove();
        if (getWishlist().length === 0) location.reload();
      }, 300);
    }
  } else {
    wishlist.push(productId);
    button.classList.add('is-active');
    button.setAttribute('aria-label', 'Quitar de favoritos');
  }
  
  saveWishlist(wishlist);
}

// Inicialización de clics y estados
function initWishlistButtons(scope) {
  const root = scope || document;
  const currentList = getWishlist();

  root.querySelectorAll('.wishlist-button, .wishlist-card-heart').forEach(button => {
    if (button.dataset.wishlistBound) return;
    button.dataset.wishlistBound = 'true';

    const productId = button.getAttribute('data-product-id') || 
                      button.closest('[data-wishlist-item]')?.dataset.wishlistItem;

    if (productId && currentList.includes(productId.toString())) {
      button.classList.add('is-active');
      button.setAttribute('aria-label', 'Quitar de favoritos');
    }

    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (productId) toggleWishlist(productId, button);
    });
  });
}

window.initWishlistButtons = initWishlistButtons;

document.addEventListener('DOMContentLoaded', () => {
  initWishlistButtons();

  // Los recomendados (y cualquier otro bloque que cargue después vía AJAX)
  // se insertan en el DOM más tarde, así que su corazón nunca se pintaba/activaba.
  // Este observer detecta cualquier corazón nuevo que aparezca y lo inicializa.
  if (window.MutationObserver) {
    const wishlistObserver = new MutationObserver(() => {
      initWishlistButtons();
    });
    wishlistObserver.observe(document.body, { childList: true, subtree: true });
  }
});